import { AttachmentValidationRules, RootDispatch } from "./types";

export type Action = {
  type: "attachments/setValidationRules";
  rules: AttachmentValidationRules;
};

export const setRules = (rules: AttachmentValidationRules) => async (dispatch: RootDispatch) => {
  dispatch({
    type: "attachments/setValidationRules",
    rules: rules
  });
};
